import React from "react";
import { _goToProducts } from "router/helper";

import { View, StyleSheet, TouchableOpacity, Platform } from "react-native";

import Text from "component/typography/Text";
import Icon from "component/typography/Icon";

import { sizes, colors } from "asset/constant";
import { css } from "style";
import { sn } from "utils";

export default function CategoryCard(props: { category: CategoryT }) {
  const { category } = props;
  const hasChild = category.children && category.children.length > 0;

  const _onParentPress = () => {
    if (hasChild) {
      return;
    }
    _goToProducts({ id: category.id, title: category.title });
  };

  const _onChildPress = (child: CategoryT) =>
    _goToProducts({ id: child.id, title: child.title });

  return (
    <View style={{ marginBottom: 25 }}>
      <TouchableOpacity
        onPress={_onParentPress}
        activeOpacity={hasChild ? 1 : sizes.tapOpacity}
        style={{
          ...css.rRowCenterAlign,
          paddingRight: 20,
          paddingLeft: 15,
          ...(!hasChild && {
            height: "auto",
            alignSelf: "flex-end",
            paddingVertical: 15,
            borderWidth: 1,
            borderColor: colors.border.light,
            borderRadius: sizes.radius.md,
          }),
        }}
      >
        <View
          style={{
            ...css.fix,
            ...css.circle(10),
            backgroundColor: colors.theme,
            ...Platform.select({
              native: { left: 3 },
              web: { right: 3 },
            }),
          }}
        />

        <Text
          style={{ bottom: 2, marginRight: 15 }}
          color={colors.theme}
          weight="bold"
          size={"xl"}
        >
          {category.title?.trim()}
        </Text>

        {!hasChild && (
          <View style={styles.arrowContainer}>
            <Icon name="left" color={colors.text.normal} size={15} />
          </View>
        )}
      </TouchableOpacity>
      <View>
        <View style={styles.childrenContainer}>
          {hasChild &&
            category?.children?.map((child, key) => {
              return (
                <TouchableOpacity
                  key={String(key)}
                  style={styles.child}
                  activeOpacity={sizes.tapOpacity}
                  onPress={() => _onChildPress(child)}
                >
                  <View
                    style={{
                      ...css.fix,
                      ...css.circle(100),
                      ...css.border(1, colors.theme + "08"),
                      left: -90,
                      transform: [{ translateY: 20 }],
                    }}
                  />
                  <View
                    style={{
                      ...css.fix,
                      ...css.circle(160),
                      ...css.border(1, colors.theme + "0a"),
                      right: -30,
                      transform: [{ translateY: 30 }],
                    }}
                  />
                  <Text weight="extraBold">{child.title}</Text>

                  <View style={styles.arrowContainer}>
                    <Icon name="left" size={15} color={colors.text.normal} />
                  </View>
                </TouchableOpacity>
              );
            })}
        </View>
        {hasChild && <View style={styles.verticalBar} />}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  childrenContainer: {
    ...css.wrap,
    width: "95%",
    ...css.justifyFStart,
    ...css.rRowCenterAlign,
    alignSelf: "flex-start",
    borderColor: colors.border.normal,
  },
  child: {
    ...css.rRowCenterAlign,
    overflow: "hidden",
    minWidth: sn("47%", "30%", "22%", "22%"),
    borderWidth: 1,
    paddingVertical: 15,
    borderRadius: sizes.radius.md,
    borderColor: colors.border.lightest,
    marginTop: 15,
    ...css.centralElContainer,
    justifyContent: "space-between",
    paddingLeft: 15,
    paddingRight: 10,
    ...Platform.select({
      web: { marginLeft: "2%" },
      native: { marginRight: "2%" },
    }),
  },

  arrowContainer: {
    ...css.circle(25),
    ...css.centralElements,
    marginRight: 10,
    borderColor: colors.theme + "22",
    backgroundColor: colors.bg.light,
  },

  verticalBar: {
    width: 0,
    borderRightWidth: 2,
    height: "100%",
    borderColor: colors.theme,
    position: "absolute",
    right: 7,
    borderRadius: 5,
    top: -6,
    zIndex: 5,
  },
});
